import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-155f5709"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogImage',
  props: {
    url: {}
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _ctx.url,
    class: "blog-image"
  }, null, 8, _hoisted_1))
}
}

})